import { create } from "zustand";
import { persist } from "zustand/middleware";
import {
	createEnvironmentSlice,
	type IEnvironmentState,
} from "~/lib/stateManagement/persistedState/persistedSlices/environment";
import {
	createShowroomSlice,
	type IShowroomState,
} from "~/lib/stateManagement/persistedState/persistedSlices/showroom";
import {
	createWishlistSlice,
	type IWishlistState,
} from "~/lib/stateManagement/persistedState/persistedSlices/wishlist";

export type IState = IEnvironmentState & IWishlistState & IShowroomState;

export const usePersistedStore = create<IState>()(
	persist(
		(...a) => ({
			...createEnvironmentSlice(...a),
			...createWishlistSlice(...a),
			...createShowroomSlice(...a),
		}),
		{
			name: "persisted-state",
		},
	),
);
